/**
 *
 *
 */
export function appendStyleToBody(styleCode: string, styleId: string) {
  const style = document.createElement('style')
  style.id = styleId
  style.innerHTML = styleCode
  /*                                                                                       */
  document.body.appendChild(style)
}
